
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { class_type, bool_type, float64_type, record_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { fold, length, append, collect as collect_1, sortBy, empty, singleton, contains, cons, filter, tryFind, map, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { BusinessUnitId__get_unwrap, BusinessUnitId_$reflection, LocationId_$reflection } from "./Shared.js";
import { tryFind as tryFind_1, ofList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { comparePrimitives, safeHash, equals, compare } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_2 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";

export class LocationAddress extends Record {
    constructor(Street, AddressSupplement, ZipCode, City, Country) {
        super();
        this.Street = Street;
        this.AddressSupplement = AddressSupplement;
        this.ZipCode = ZipCode;
        this.City = City;
        this.Country = Country;
    }
}

export function LocationAddress_$reflection() {
    return record_type("Shared.Location.LocationAddress", [], LocationAddress, () => [["Street", option_type(string_type)], ["AddressSupplement", option_type(string_type)], ["ZipCode", option_type(string_type)], ["City", option_type(string_type)], ["Country", option_type(string_type)]]);
}

export function LocationAddress_get_empty() {
    return new LocationAddress(undefined, undefined, undefined, undefined, undefined);
}

export class LocationCoordinates extends Record {
    constructor(Latitude, Longitude) {
        super();
        this.Latitude = Latitude;
        this.Longitude = Longitude;
    }
}

export function LocationCoordinates_$reflection() {
    return record_type("Shared.Location.LocationCoordinates", [], LocationCoordinates, () => [["Latitude", float64_type], ["Longitude", float64_type]]);
}

export class LocationCountry extends Record {
    constructor(Code) {
        super();
        this.Code = Code;
    }
}

export function LocationCountry_$reflection() {
    return record_type("Shared.Location.LocationCountry", [], LocationCountry, () => [["Code", string_type]]);
}

export const locationCountryCodes = ofArray(["ad", "ae", "af", "ag", "ai", "al", "am", "ao", "aq", "ar", "as", "at", "au", "aw", "ax", "az", "ba", "bb", "bd", "be", "bf", "bg", "bh", "bi", "bj", "bl", "bm", "bn", "bo", "bq", "br", "bs", "bt", "bv", "bw", "by", "bz", "ca", "cc", "cd", "cf", "cg", "ch", "ci", "ck", "cl", "cm", "cn", "co", "cr", "cu", "cv", "cw", "cx", "cy", "cz", "de", "dj", "dk", "dm", "do", "dz", "ec", "ee", "eg", "eh", "er", "es", "et", "fi", "fj", "fk", "fm", "fo", "fr", "ga", "gb", "gd", "ge", "gf", "gg", "gh", "gi", "gl", "gm", "gn", "gp", "gq", "gr", "gs", "gt", "gu", "gw", "gy", "hk", "hm", "hn", "hr", "ht", "hu", "id", "ie", "il", "im", "in", "io", "iq", "ir", "is", "it", "je", "jm", "jo", "jp", "ke", "kg", "kh", "ki", "km", "kn", "kp", "kr", "kw", "ky", "kz", "la", "lb", "lc", "li", "lk", "lr", "ls", "lt", "lu", "lv", "ly", "ma", "mc", "md", "me", "mf", "mg", "mh", "mk", "ml", "mm", "mn", "mo", "mp", "mq", "mr", "ms", "mt", "mu", "mv", "mw", "mx", "my", "mz", "na", "nc", "ne", "nf", "ng", "ni", "nl", "no", "np", "nr", "nu", "nz", "om", "pa", "pe", "pf", "pg", "ph", "pk", "pl", "pm", "pn", "pr", "ps", "pt", "pw", "py", "qa", "re", "ro", "rs", "ru", "rw", "sa", "sb", "sc", "sd", "se", "sg", "sh", "si", "sj", "sk", "sl", "sm", "sn", "so", "sr", "ss", "st", "sv", "sx", "sy", "sz", "tc", "td", "tf", "tg", "th", "tj", "tk", "tl", "tm", "tn", "to", "tr", "tt", "tv", "tw", "tz", "ua", "ug", "um", "us", "uy", "uz", "va", "vc", "ve", "vg", "vi", "vn", "vu", "wf", "ws", "ye", "yt", "za", "zm", "zw"]);

export const locationCountries = map((code) => (new LocationCountry(code)), locationCountryCodes);

export function tryFindLocationCountry(code) {
    return tryFind((country) => (country.Code === code), locationCountries);
}

const regionalIndicatorBase = 127462;

function surrogatePair(codePoint) {
    const offset = (codePoint - 65536) | 0;
    return String.fromCharCode((55296 + (offset >> 10)) & 0xFFFF) + String.fromCharCode((56320 + (offset & 1023)) & 0xFFFF);
}

export function countryFlag(code) {
    return join("", map_1((letter) => surrogatePair((regionalIndicatorBase + ~~letter.charCodeAt(0)) - ~~"A".charCodeAt(0)), code.toUpperCase().split("")));
}

export class Location extends Record {
    constructor(Id, Name, Description, ImageUrl, Address, Coordinates, ParentLocationId, BusinessUnitId, BusinessUnitName, IsDeleted, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
        this.Address = Address;
        this.Coordinates = Coordinates;
        this.ParentLocationId = ParentLocationId;
        this.BusinessUnitId = BusinessUnitId;
        this.BusinessUnitName = BusinessUnitName;
        this.IsDeleted = IsDeleted;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function Location_$reflection() {
    return record_type("Shared.Location.Location", [], Location, () => [["Id", LocationId_$reflection()], ["Name", string_type], ["Description", string_type], ["ImageUrl", string_type], ["Address", LocationAddress_$reflection()], ["Coordinates", option_type(LocationCoordinates_$reflection())], ["ParentLocationId", option_type(LocationId_$reflection())], ["BusinessUnitId", option_type(BusinessUnitId_$reflection())], ["BusinessUnitName", option_type(string_type)], ["IsDeleted", bool_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class LocationDetailDto extends Record {
    constructor(Id, Name, BusinessUnitName, BusinessUnitId, Description, ImageUrl, Address, ParentLocationId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.BusinessUnitName = BusinessUnitName;
        this.BusinessUnitId = BusinessUnitId;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
        this.Address = Address;
        this.ParentLocationId = ParentLocationId;
    }
}

export function LocationDetailDto_$reflection() {
    return record_type("Shared.Location.LocationDetailDto", [], LocationDetailDto, () => [["Id", string_type], ["Name", string_type], ["BusinessUnitName", option_type(string_type)], ["BusinessUnitId", option_type(string_type)], ["Description", string_type], ["ImageUrl", string_type], ["Address", LocationAddress_$reflection()], ["ParentLocationId", option_type(string_type)]]);
}

export class LocationCreateOrUpdateDto extends Record {
    constructor(Name, Description, Address, ParentLocationId, BusinessUnitId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Address = Address;
        this.ParentLocationId = ParentLocationId;
        this.BusinessUnitId = BusinessUnitId;
    }
}

export function LocationCreateOrUpdateDto_$reflection() {
    return record_type("Shared.Location.LocationCreateOrUpdateDto", [], LocationCreateOrUpdateDto, () => [["Name", string_type], ["Description", string_type], ["Address", option_type(LocationAddress_$reflection())], ["ParentLocationId", option_type(string_type)], ["BusinessUnitId", option_type(string_type)]]);
}

function Hierarchy_activeLocations(locations) {
    return filter((location) => !location.IsDeleted, locations);
}

export function Hierarchy_getAncestors(locations, location) {
    const locationMap = ofList(map((l) => [l.Id, l], Hierarchy_activeLocations(locations)), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const collect = (visited_mut, acc_mut, parentId_mut) => {
        collect:
        while (true) {
            const visited = visited_mut, acc = acc_mut, parentId = parentId_mut;
            let matchResult, parentId_2;
            if (parentId != null) {
                if (!contains(parentId, visited, {
                    Equals: equals,
                    GetHashCode: (x_1) => (safeHash(x_1) | 0),
                })) {
                    matchResult = 0;
                    parentId_2 = parentId;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const matchValue = tryFind_1(parentId_2, locationMap);
                    if (matchValue == null) {
                        return acc;
                    }
                    else {
                        const parent = matchValue;
                        visited_mut = cons(parentId_2, visited);
                        acc_mut = cons(parent, acc);
                        parentId_mut = parent.ParentLocationId;
                        continue collect;
                    }
                }
                default:
                    return acc;
            }
            break;
        }
    };
    return collect(singleton(location.Id), empty(), location.ParentLocationId);
}

export function Hierarchy_getChildren(locations, locationId) {
    return sortBy((l_1) => l_1.Name.toLocaleLowerCase(), filter((l) => equals(l.ParentLocationId, locationId), Hierarchy_activeLocations(locations)), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
}

export function Hierarchy_getDescendants(locations, locationId) {
    const collect = (visited, parentId) => collect_1((child_1) => cons(child_1, collect(cons(child_1.Id, visited), child_1.Id)), filter((child) => !contains(child.Id, visited, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), Hierarchy_getChildren(locations, parentId)));
    return collect(singleton(locationId), locationId);
}

export function Hierarchy_getPathNames(locations, location) {
    return append(map((_arg) => _arg.Name, Hierarchy_getAncestors(locations, location)), singleton(location.Name));
}

export function Hierarchy_getPath(locations, location) {
    return join(" > ", Hierarchy_getPathNames(locations, location));
}

export function Hierarchy_getPathById(locations, locationId) {
    return map_2((location_1) => Hierarchy_getPath(locations, location_1), tryFind((location) => equals(location.Id, locationId), locations));
}

export function Hierarchy_getDepth(locations, location) {
    return (length(Hierarchy_getAncestors(locations, location)) + 1) | 0;
}

export function Hierarchy_getSubtreeHeight(locations, locationId) {
    const height = (visited, currentId) => ((1 + fold((e, e_1) => (max(e, e_1) | 0), 0, map((child_1) => (height(cons(child_1.Id, visited), child_1.Id) | 0), filter((child) => !contains(child.Id, visited, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), Hierarchy_getChildren(locations, currentId))))) | 0);
    return height(singleton(locationId), locationId) | 0;
}

export function Hierarchy_getSelfAndDescendantIds(locations, locationId) {
    return cons(locationId, map((_arg) => _arg.Id, Hierarchy_getDescendants(locations, locationId)));
}

export function Hierarchy_getPossibleParents(locations, locationId) {
    const excludedIds = (locationId == null) ? empty() : Hierarchy_getSelfAndDescendantIds(locations, locationId);
    const subtreeHeight = ((locationId == null) ? 1 : Hierarchy_getSubtreeHeight(locations, locationId)) | 0;
    return filter((candidate) => {
        if (!contains(candidate.Id, excludedIds, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })) {
            return (Hierarchy_getDepth(locations, candidate) + subtreeHeight) <= 5;
        }
        else {
            return false;
        }
    }, Hierarchy_activeLocations(locations));
}

export function Hierarchy_isInBusinessUnit(businessUnitId, location) {
    const matchValue = location.BusinessUnitId;
    if (matchValue == null) {
        return true;
    }
    else {
        return equals(BusinessUnitId__get_unwrap(matchValue), businessUnitId);
    }
}

export function Hierarchy_isSameOrDescendantPath(selectedPath, path) {
    if (path === selectedPath) {
        return true;
    }
    else {
        return path.startsWith(selectedPath + " > ");
    }
}

export function Hierarchy_buildTreeOrderedList(locations) {
    const active = Hierarchy_activeLocations(locations);
    const activeIds = map((_arg) => _arg.Id, active);
    const build = (visited, parent, depth) => collect_1((child_1) => cons([child_1, depth], build(cons(child_1.Id, visited), child_1, depth + 1)), filter((child) => !contains(child.Id, visited, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }), Hierarchy_getChildren(active, parent.Id)));
    return collect_1((root) => cons([root, 0], build(singleton(root.Id), root, 1)), sortBy((l) => l.Name.toLocaleLowerCase(), filter((location) => {
        const matchValue = location.ParentLocationId;
        if (matchValue == null) {
            return true;
        }
        else {
            return !contains(matchValue, activeIds, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            });
        }
    }, active), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }));
}

